export enum ECOLOR {
  COLOR0 = '#bdd5e9',
  COLOR1 = '#96BFE3',
  COLOR2 = '#9FA3AE',
  COLOR3 = '#6F7B8B',
  COLOR4 = '#465767',
  COLOR5 = '#2B424A',
  COLOR6 = '#13333E',
  COLOR7 = '#216785',
  COLOR8 = '#0b1f26',
}
